import Graylog from 'components/domain/analytics/Graylog/Graylog';
import { useActiveMember } from 'hooks';
import { useCallback, useMemo } from 'react';
import AnalyticsEvent from 'utils/constants/analytics/analyticsEvent';

function useTimesheetsAnalytics() {
  const member = useActiveMember();

  const timesheetsSummaryExported = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEET_SUMMARY_EXPORT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsBasicExported = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_BASIC_EXPORT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsExpandedExported = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_EXPANDED_EXPORT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsEntriesExported = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_ENTRIES_EXPORT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsWeeklyGridExported = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_WEEKLY_GRID_EXPORT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsSummaryPrinted = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_SUMMARY_PRINT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsBasicPrinted = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_BASIC_PRINT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsExpandedPrinted = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_EXPANDED_PRINT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsEntriesPrinted = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_ENTRIES_PRINT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const timesheetsWeeklyGridPrinted = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.timesheets.TIMESHEETS_WEEKLY_GRID_PRINT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);
  

  return useMemo(
    () => ({
      timesheetsSummaryExported,
      timesheetsBasicExported,
      timesheetsExpandedExported,
      timesheetsEntriesExported,
      timesheetsWeeklyGridExported,
      timesheetsSummaryPrinted,
      timesheetsBasicPrinted,
      timesheetsExpandedPrinted,
      timesheetsEntriesPrinted,
      timesheetsWeeklyGridPrinted,
    }),
    [
      timesheetsSummaryExported,
      timesheetsBasicExported,
      timesheetsExpandedExported,
      timesheetsEntriesExported,
      timesheetsWeeklyGridExported,
      timesheetsSummaryPrinted,
      timesheetsBasicPrinted,
      timesheetsExpandedPrinted,
      timesheetsEntriesPrinted,
      timesheetsWeeklyGridPrinted,
    ]
  );
}

export default useTimesheetsAnalytics;
